module.exports = new __parcel__URL__("feed_title_image.9f8f4fd3.png").toString();